import Vue from 'vue';

Vue.filter('price', function (value) {
    if(value === null) {
        return 'N/A';
    }

    value = value.toLocaleString('en-US', {maximumFrationDigits: 2});
    if(value.indexOf('.') === -1) {
        value += '.—';
    }
    return `€ ${value}`;
});
